import { trackPageView } from '../util/analytics'

up.compiler('[track-page-view]', (element, data, { revalidating }) => {
  if (!revalidating) {
    trackPageView(data)
  }
})
